import script from "./FacebookButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./FacebookButton.vue?vue&type=script&setup=true&lang=ts"

import "./FacebookButton.vue?vue&type=style&index=0&id=59d0d90e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d0d90e"]])

export default __exports__